<template>
  <div class="report">
    <h3>Survey Completed!</h3>
    <p>You have successfuly completed the survey.The report has been emailed to you. Please check your email to download your results. </p>
    <hr>
    <div>
        <button type="button" v-on:click="emailReport" class="btn btn-primary">Re-send Email</button>
        <button type="button" v-on:click="downloadReport" class="btn btn-success">Download Report</button>
        
    </div>
  </div>
</template>

<script>
const apiUrl = 'https://t3.talkingtowardtruth.org/api/';

export default {
  name: 'Report',
  
  data () {
    return {
      
    }
  },
  methods :{
      downloadReport : function(e){
         var user_id = this.$cookie.get('user_id');
         this.$http.get(apiUrl+'report/'+user_id).then(response => {
                var filename = response.body.filename;
                e.preventDefault();
                
                window.open('https://t3.talkingtowardtruth.org/reports/'+filename,'_blank');
                // window.location.href = 'https://t3.talkingtowardtruth.org/reports/'+filename;
             },error=>{})
      },
      emailReport : function(){
         var user_id = this.$cookie.get('user_id');
 this.$http.get(apiUrl+'email/'+user_id).then(response => {
                var filename = response.body.filename;
                alert('Email is sent!');
             },error=>{})
      }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Report.vue